import { render, staticRenderFns } from "./ProdEditMain.vue?vue&type=template&id=4004ac7c&scoped=true&"
import script from "./ProdEditMain.vue?vue&type=script&lang=js&"
export * from "./ProdEditMain.vue?vue&type=script&lang=js&"
import style0 from "./ProdEditMain.vue?vue&type=style&index=0&id=4004ac7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4004ac7c",
  null
  
)

export default component.exports